import { render, staticRenderFns } from "./image-pull-tasks.vue?vue&type=template&id=b08e5bfe&scoped=true&"
import script from "./image-pull-tasks.vue?vue&type=script&lang=js&"
export * from "./image-pull-tasks.vue?vue&type=script&lang=js&"
import style0 from "./image-pull-tasks.vue?vue&type=style&index=0&id=b08e5bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08e5bfe",
  null
  
)

export default component.exports